import ReactDOM from 'react-dom/client'
import { Toaster } from 'react-hot-toast'
import { Provider } from 'react-redux'
import App from './App'
import { store } from './app/store'
import './index.css'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { theme } from './theme'
import ModalProvider from './app/hooks/useModal'
import { HelmetProvider } from 'react-helmet-async'
import ConfirmProvider from './app/hooks/useConfirm'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

const defaultTheme = createTheme(theme)

root.render(
  <HelmetProvider>
    <Provider store={store}>
      <ThemeProvider theme={defaultTheme}>
        <ConfirmProvider>
          <ModalProvider>
            <Toaster />
            <App />
          </ModalProvider>
        </ConfirmProvider>
      </ThemeProvider>
    </Provider>
  </HelmetProvider>,
)
